// liability reducer
import {
  GET_LIABILITY_LIST,
  GET_LIABILITY_LIST_SUCCESS,
  GET_LIABILITY_LIST_FAILURE,
  GET_LIABILITY_DETAIL,
  GET_LIABILITY_DETAIL_SUCCESS,
  GET_LIABILITY_DETAIL_FAILURE,
  CREATE_LIABILITY,
  CREATE_LIABILITY_SUCCESS,
  CREATE_LIABILITY_FAILURE,
  UPDATE_LIABILITY,
  UPDATE_LIABILITY_SUCCESS,
  UPDATE_LIABILITY_FAILURE,
  DELETE_LIABILITY,
  DELETE_LIABILITY_SUCCESS,
  DELETE_LIABILITY_FAILURE,
  GET_LIABILITY_PROVIDER_LIST,
  GET_LIABILITY_PROVIDER_LIST_SUCCESS,
  GET_LIABILITY_PROVIDER_LIST_FAILURE,
  GET_LIABILITY_PROVIDER_DETAIL,
  GET_LIABILITY_PROVIDER_DETAIL_SUCCESS,
  GET_LIABILITY_PROVIDER_DETAIL_FAILURE,
  CREATE_LIABILITY_PROVIDER,
  CREATE_LIABILITY_PROVIDER_SUCCESS,
  CREATE_LIABILITY_PROVIDER_FAILURE,
  UPDATE_LIABILITY_PROVIDER,
  UPDATE_LIABILITY_PROVIDER_SUCCESS,
  UPDATE_LIABILITY_PROVIDER_FAILURE,
  DELETE_LIABILITY_PROVIDER,
  DELETE_LIABILITY_PROVIDER_SUCCESS,
  DELETE_LIABILITY_PROVIDER_FAILURE,
  GET_LIABILITY_STATUS_LIST,
  GET_LIABILITY_STATUS_LIST_SUCCESS,
  GET_LIABILITY_STATUS_LIST_FAILURE,
  GET_LIABILITY_STATUS_DETAIL,
  GET_LIABILITY_STATUS_DETAIL_SUCCESS,
  GET_LIABILITY_STATUS_DETAIL_FAILURE,
  CREATE_LIABILITY_STATUS,
  CREATE_LIABILITY_STATUS_SUCCESS,
  CREATE_LIABILITY_STATUS_FAILURE,
  UPDATE_LIABILITY_STATUS,
  UPDATE_LIABILITY_STATUS_SUCCESS,
  UPDATE_LIABILITY_STATUS_FAILURE,
  DELETE_LIABILITY_STATUS,
  DELETE_LIABILITY_STATUS_SUCCESS,
  DELETE_LIABILITY_STATUS_FAILURE,
  GET_LIABILITY_ITEM_CATEGORY_LIST,
  GET_LIABILITY_ITEM_CATEGORY_LIST_SUCCESS,
  GET_LIABILITY_ITEM_CATEGORY_LIST_FAILURE,
  GET_LIABILITY_ITEM_CATEGORY_DETAIL,
  GET_LIABILITY_ITEM_CATEGORY_DETAIL_SUCCESS,
  GET_LIABILITY_ITEM_CATEGORY_DETAIL_FAILURE,
  CREATE_LIABILITY_ITEM_CATEGORY,
  CREATE_LIABILITY_ITEM_CATEGORY_SUCCESS,
  CREATE_LIABILITY_ITEM_CATEGORY_FAILURE,
  UPDATE_LIABILITY_ITEM_CATEGORY,
  UPDATE_LIABILITY_ITEM_CATEGORY_SUCCESS,
  UPDATE_LIABILITY_ITEM_CATEGORY_FAILURE,
  DELETE_LIABILITY_ITEM_CATEGORY,
  DELETE_LIABILITY_ITEM_CATEGORY_SUCCESS,
  DELETE_LIABILITY_ITEM_CATEGORY_FAILURE,
} from "./actionType";

const initialState = {
  liabilityList: [],
  liabilityListLoading: false,
  liabilityListError: null,
  liabilityDetail: [],
  liabilityDetailLoading: false,
  liabilityDetailError: null,
  createLiabilitySuccess: [],
  createLiabilityLoading: false,
  createLiabilityError: null,
  updateLiabilitySuccess: [],
  updateLiabilityLoading: false,
  updateLiabilityError: null,
  deleteLiabilitySuccess: [],
  deleteLiabilityLoading: false,
  deleteLiabilityError: null,
  liabilityProviderList: [],
  liabilityProviderListLoading: false,
  liabilityProviderListError: null,
  liabilityProviderDetail: [],
  liabilityProviderDetailLoading: false,
  liabilityProviderDetailError: null,
  createLiabilityProviderSuccess: [],
  createLiabilityProviderLoading: false,
  createLiabilityProviderError: null,
  updateLiabilityProviderSuccess: [],
  updateLiabilityProviderLoading: false,
  updateLiabilityProviderError: null,
  deleteLiabilityProviderSuccess: [],
  deleteLiabilityProviderLoading: false,
  deleteLiabilityProviderError: null,
  liabilityStatusList: [],
  liabilityStatusListLoading: false,
  liabilityStatusListError: null,
  liabilityStatusDetail: [],
  liabilityStatusDetailLoading: false,
  liabilityStatusDetailError: null,
  createLiabilityStatusSuccess: [],
  createLiabilityStatusLoading: false,
  createLiabilityStatusError: null,
  updateLiabilityStatusSuccess: [],
  updateLiabilityStatusLoading: false,
  updateLiabilityStatusError: null,
  deleteLiabilityStatusSuccess: [],
  deleteLiabilityStatusLoading: false,
  deleteLiabilityStatusError: null,
  liabilityItemCategoryList: [],
  liabilityItemCategoryListLoading: false,
  liabilityItemCategoryListError: null,
  liabilityItemCategoryDetail: [],
  liabilityItemCategoryDetailLoading: false,
  liabilityItemCategoryDetailError: null,
  createLiabilityItemCategorySuccess: [],
  createLiabilityItemCategoryLoading: false,
  createLiabilityItemCategoryError: null,
  updateLiabilityItemCategorySuccess: [],
  updateLiabilityItemCategoryLoading: false,
  updateLiabilityItemCategoryError: null,
  deleteLiabilityItemCategorySuccess: [],
  deleteLiabilityItemCategoryLoading: false,
  deleteLiabilityItemCategoryError: null,
};

const Liability = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIABILITY_LIST:
      return {
        ...state,
        liabilityListLoading: true,
      };
    case GET_LIABILITY_LIST_SUCCESS:
      return {
        ...state,
        liabilityListLoading: false,
        liabilityList: action.payload,
      };
    case GET_LIABILITY_LIST_FAILURE:
      return {
        ...state,
        liabilityListLoading: false,
        liabilityListError: action.payload,
      };
    case GET_LIABILITY_DETAIL:
      return {
        ...state,
        liabilityDetailLoading: true,
      };
    case GET_LIABILITY_DETAIL_SUCCESS:
      return {
        ...state,
        liabilityDetailLoading: false,
        liabilityDetail: action.payload,
      };
    case GET_LIABILITY_DETAIL_FAILURE:
      return {
        ...state,
        liabilityDetailLoading: false,
        liabilityDetailError: action.payload,
      };
    case CREATE_LIABILITY:
      return {
        ...state,
        createLiabilityLoading: true,
      };
    case CREATE_LIABILITY_SUCCESS:
      return {
        ...state,
        createLiabilityLoading: false,
        createLiabilitySuccess: action.payload,
      };
    case CREATE_LIABILITY_FAILURE:
      return {
        ...state,
        createLiabilityLoading: false,
        createLiabilityError: action.payload,
      };
    case UPDATE_LIABILITY:
      return {
        ...state,
        updateLiabilityLoading: true,
      };
    case UPDATE_LIABILITY_SUCCESS:
      return {
        ...state,
        updateLiabilityLoading: false,
        updateLiabilitySuccess: action.payload,
      };
    case UPDATE_LIABILITY_FAILURE:
      return {
        ...state,
        updateLiabilityLoading: false,
        updateLiabilityError: action.payload,
      };
    case DELETE_LIABILITY:
      return {
        ...state,
        deleteLiabilityLoading: true,
      };
    case DELETE_LIABILITY_SUCCESS:
      return {
        ...state,

        deleteLiabilityLoading: false,
        deleteLiabilitySuccess: action.payload,
      };
    case DELETE_LIABILITY_FAILURE:
      return {
        ...state,
        deleteLiabilityLoading: false,
        deleteLiabilityError: action.payload,
      };
    case GET_LIABILITY_PROVIDER_LIST:
      return {
        ...state,
        liabilityProviderListLoading: true,
      };
    case GET_LIABILITY_PROVIDER_LIST_SUCCESS:
      return {
        ...state,
        liabilityProviderListLoading: false,
        liabilityProviderList: action.payload,
      };
    case GET_LIABILITY_PROVIDER_LIST_FAILURE:
      return {
        ...state,
        liabilityProviderListLoading: false,
        liabilityProviderListError: action.payload,
      };
    case GET_LIABILITY_PROVIDER_DETAIL:
      return {
        ...state,
        liabilityProviderDetailLoading: true,
      };
    case GET_LIABILITY_PROVIDER_DETAIL_SUCCESS:
      return {
        ...state,
        liabilityProviderDetailLoading: false,
        liabilityProviderDetail: action.payload,
      };
    case GET_LIABILITY_PROVIDER_DETAIL_FAILURE:
      return {
        ...state,
        liabilityProviderDetailLoading: false,
        liabilityProviderDetailError: action.payload,
      };
    case CREATE_LIABILITY_PROVIDER:
      return {
        ...state,
        createLiabilityProviderLoading: true,
      };
    case CREATE_LIABILITY_PROVIDER_SUCCESS:
      return {
        ...state,
        createLiabilityProviderLoading: false,
        createLiabilityProviderSuccess: action.payload,
      };
    case CREATE_LIABILITY_PROVIDER_FAILURE:
      return {
        ...state,
        createLiabilityProviderLoading: false,
        createLiabilityProviderError: action.payload,
      };
    case UPDATE_LIABILITY_PROVIDER:
      return {
        ...state,
        updateLiabilityProviderLoading: true,
      };
    case UPDATE_LIABILITY_PROVIDER_SUCCESS:
      return {
        ...state,
        updateLiabilityProviderLoading: false,
        updateLiabilityProviderSuccess: action.payload,
      };
    case UPDATE_LIABILITY_PROVIDER_FAILURE:
      return {
        ...state,
        updateLiabilityProviderLoading: false,
        updateLiabilityProviderError: action.payload,
      };
    case DELETE_LIABILITY_PROVIDER:
      return {
        ...state,
        deleteLiabilityProviderLoading: true,
      };
    case DELETE_LIABILITY_PROVIDER_SUCCESS:
      return {
        ...state,
        deleteLiabilityProviderLoading: false,
        deleteLiabilityProviderSuccess: action.payload,
      };
    case DELETE_LIABILITY_PROVIDER_FAILURE:
      return {
        ...state,
        deleteLiabilityProviderLoading: false,
        deleteLiabilityProviderError: action.payload,
      };
    case GET_LIABILITY_STATUS_LIST:
      return {
        ...state,
        liabilityStatusListLoading: true,
      };
    case GET_LIABILITY_STATUS_LIST_SUCCESS:
      return {
        ...state,
        liabilityStatusListLoading: false,
        liabilityStatusList: action.payload,
      };
    case GET_LIABILITY_STATUS_LIST_FAILURE:
      return {
        ...state,
        liabilityStatusListLoading: false,
        liabilityStatusListError: action.payload,
      };
    case GET_LIABILITY_STATUS_DETAIL:
      return {
        ...state,
        liabilityStatusDetailLoading: true,
      };
    case GET_LIABILITY_STATUS_DETAIL_SUCCESS:
      return {
        ...state,
        liabilityStatusDetailLoading: false,
        liabilityStatusDetail: action.payload,
      };
    case GET_LIABILITY_STATUS_DETAIL_FAILURE:
      return {
        ...state,
        liabilityStatusDetailLoading: false,
        liabilityStatusDetailError: action.payload,
      };
    case CREATE_LIABILITY_STATUS:
      return {
        ...state,
        createLiabilityStatusLoading: true,
      };
    case CREATE_LIABILITY_STATUS_SUCCESS:
      return {
        ...state,
        createLiabilityStatusLoading: false,
        createLiabilityStatusSuccess: action.payload,
      };
    case CREATE_LIABILITY_STATUS_FAILURE:
      return {
        ...state,
        createLiabilityStatusLoading: false,
        createLiabilityStatusError: action.payload,
      };
    case UPDATE_LIABILITY_STATUS:
      return {
        ...state,
        updateLiabilityStatusLoading: true,
      };
    case UPDATE_LIABILITY_STATUS_SUCCESS:
      return {
        ...state,
        updateLiabilityStatusLoading: false,
        updateLiabilityStatusSuccess: action.payload,
      };
    case UPDATE_LIABILITY_STATUS_FAILURE:
      return {
        ...state,
        updateLiabilityStatusLoading: false,
        updateLiabilityStatusError: action.payload,
      };
    case DELETE_LIABILITY_STATUS:
      return {
        ...state,
        deleteLiabilityStatusLoading: true,
      };
    case DELETE_LIABILITY_STATUS_SUCCESS:
      return {
        ...state,
        deleteLiabilityStatusLoading: false,
        deleteLiabilityStatusSuccess: action.payload,
      };
    case DELETE_LIABILITY_STATUS_FAILURE:
      return {
        ...state,
        deleteLiabilityStatusLoading: false,
        deleteLiabilityStatusError: action.payload,
      };
    case GET_LIABILITY_ITEM_CATEGORY_LIST:
      return {
        ...state,
        liabilityItemCategoryListLoading: true,
      };
    case GET_LIABILITY_ITEM_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        liabilityItemCategoryListLoading: false,
        liabilityItemCategoryList: action.payload,
      };
    case GET_LIABILITY_ITEM_CATEGORY_LIST_FAILURE:
      return {
        ...state,
        liabilityItemCategoryListLoading: false,
        liabilityItemCategoryListError: action.payload,
      };
    case GET_LIABILITY_ITEM_CATEGORY_DETAIL:
      return {
        ...state,
        liabilityItemCategoryDetailLoading: true,
      };
    case GET_LIABILITY_ITEM_CATEGORY_DETAIL_SUCCESS:
      return {
        ...state,
        liabilityItemCategoryDetailLoading: false,
        liabilityItemCategoryDetail: action.payload,
      };
    case GET_LIABILITY_ITEM_CATEGORY_DETAIL_FAILURE:
      return {
        ...state,
        liabilityItemCategoryDetailLoading: false,
        liabilityItemCategoryDetailError: action.payload,
      };
    case CREATE_LIABILITY_ITEM_CATEGORY:
      return {
        ...state,
        createLiabilityItemCategoryLoading: true,
      };
    case CREATE_LIABILITY_ITEM_CATEGORY_SUCCESS:
      return {
        ...state,
        createLiabilityItemCategoryLoading: false,
        createLiabilityItemCategorySuccess: action.payload,
      };
    case CREATE_LIABILITY_ITEM_CATEGORY_FAILURE:
      return {
        ...state,
        createLiabilityItemCategoryLoading: false,
        createLiabilityItemCategoryError: action.payload,
      };
    case UPDATE_LIABILITY_ITEM_CATEGORY:
      return {
        ...state,
        updateLiabilityItemCategoryLoading: true,
      };
    case UPDATE_LIABILITY_ITEM_CATEGORY_SUCCESS:
      return {
        ...state,
        updateLiabilityItemCategoryLoading: false,
        updateLiabilityItemCategorySuccess: action.payload,
      };
    case UPDATE_LIABILITY_ITEM_CATEGORY_FAILURE:
      return {
        ...state,
        updateLiabilityItemCategoryLoading: false,
        updateLiabilityItemCategoryError: action.payload,
      };
    case DELETE_LIABILITY_ITEM_CATEGORY:
      return {
        ...state,
        deleteLiabilityItemCategoryLoading: true,
      };
    case DELETE_LIABILITY_ITEM_CATEGORY_SUCCESS:
      return {
        ...state,
        deleteLiabilityItemCategoryLoading: false,
        deleteLiabilityItemCategorySuccess: action.payload,
      };
    case DELETE_LIABILITY_ITEM_CATEGORY_FAILURE:
      return {
        ...state,
        deleteLiabilityItemCategoryLoading: false,
        deleteLiabilityItemCategoryError: action.payload,
      };

    default:
      return state;
  }
};

export default Liability;
